import { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import SocialLinks from './SocialLinks';
import Wordmark from './Wordmark';
import { navLinks, startLinkProps } from '../data';

export default function Header() {
  const { pathname } = useLocation();
  const onHome = pathname === '/';
  const [menuOpen, setMenuOpen] = useState(false);
  const [scrolled, setScrolled] = useState(!onHome);

  useEffect(() => {
    setMenuOpen(false);
    if (!onHome) {
      setScrolled(true);
      return undefined;
    }

    const onScroll = () => setScrolled(window.scrollY > 12);
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, [onHome, pathname]);

  return (
    <header className={`site-header${scrolled ? ' is-scrolled' : ''}${menuOpen ? ' is-menu-open' : ''}`}>
      <div className="header-inner">
        <Wordmark />

        <nav className="desktop-nav" aria-label="Main navigation">
          {navLinks.map((link) => (
            <Link key={link.href} to={link.href}>
              {link.label}
            </Link>
          ))}
        </nav>

        <div className="header-actions">
          <SocialLinks />
          <button
            type="button"
            className="menu-toggle"
            aria-expanded={menuOpen}
            aria-controls="mobile-nav"
            aria-label={menuOpen ? 'Close navigation menu' : 'Open navigation menu'}
            onClick={() => setMenuOpen((open) => !open)}
          >
            <span className={menuOpen ? 'bars is-open' : 'bars'} aria-hidden="true">
              <i />
              <i />
            </span>
          </button>
        </div>
      </div>

      <nav
        id="mobile-nav"
        className={menuOpen ? 'mobile-nav is-open' : 'mobile-nav'}
        aria-label="Mobile navigation"
        hidden={!menuOpen}
      >
        {navLinks.map((link) => (
          <Link key={link.href} to={link.href} onClick={() => setMenuOpen(false)}>
            {link.label}
          </Link>
        ))}
        <SocialLinks />
        <a className="btn btn-primary" {...startLinkProps} onClick={() => setMenuOpen(false)}>
          Schedule a call
        </a>
      </nav>
    </header>
  );
}
